module.exports = __webpack_public_path__ + "img/5.bc57d622.png";